// Composant BANDE
import { Fragment, h } from 'preact'
import { signal } from '@preact/signals'
import { useLayoutEffect } from 'preact/hooks'
import { setAllToMaxHeight } from '../../js/modules/setAllToMaxHeight.js'
import { tagParser } from '../../js/modules/utilities.js'
import { attributesAnalytics } from '../../js/modules/component'
var isSmartphone = require('is-mobile')

export const recoEquipementsState = signal('')

// Composant principal
export const RecoEquipements = ({ title, items, viewAllCategories, device = isSmartphone() ? 'mobile' : 'desktop', popin = false, segRefZ }) => {
   // ABTEST 5689 Transparence IA
   popin = recoEquipementsState.value['popin'] !== undefined ? recoEquipementsState.value['popin'] : popin

   useLayoutEffect(() => {
      if (device !== 'mobile') {
         setAllToMaxHeight('.js-reco-title')
      }

      //=================== abtest 5689 Transparence IA ===================
      if (popin) {
         // Bouton ouverture modal
         const modalButton = document.querySelector('#modalButton')
         modalButton.addEventListener('click', function () {
            // show modal
            const modal = document.querySelector('.modal')
            modal.classList.add('show')
            modal.style.display = 'block'
            // freeze body scroll
            document.body.classList.add('modal-open')
            // creation et affichage du backdrop
            const modalBackdrop = document.createElement('div')
            modalBackdrop.classList.add('modal-backdrop', 'fade', 'show')
            modalBackdrop.style.display = 'block'
            document.body.appendChild(modalBackdrop)
         })

         // Bouton fermeture modal
         const closeButton = document.querySelectorAll('.closeButton')
         closeButton.forEach((item) =>
            item.addEventListener('click', function () {
               closeModal()
            })
         )

         // Close modal on click outside
         const modal = document.querySelector('.modal')
         modal.addEventListener('click', function (e) {
            if (e.target === modal) {
               closeModal()
            }
         })

         // Close modal on escape key
         document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') {
               closeModal()
            }
         })

         // Close modal function
         const closeModal = () => {
            // hide modal
            const modal = document.querySelector('.modal')
            modal.classList.remove('show')
            modal.setAttribute('style', 'display: none;')
            // unfreeze body scroll
            document.body.classList.remove('modal-open')
            // suppression du backdrop
            const modalBackdrop = document.querySelector('.modal-backdrop')
            document.body.removeChild(modalBackdrop)
         }
      }

      //=================== FIN abtest 5689 ===================
   }, [popin]) // s'execute à chaque changement de "popin"

   return (
      <div class="reco-equipements bg-gray2 pt-3 pb-2 mb-2 mb-xl-3" data-testid="bande-reco-equipements">
         <div class="container-fluid">
            <div class="row">
               <div class="col-12">
                  <h2 class="mb-2 mb-xl-3 mw-100">{title}</h2>
                  {popin && <TransparenceIA segRefZ={segRefZ} />}
               </div>
               <div class="col-12">
                  <ul class="row slider-eqpt mb-0 list-unstyled">
                     {items.map((item, index) => (
                        <Equipement {...item} index={index + 1} />
                     ))}
                  </ul>
               </div>
               <div class="col-12 d-flex justify-content-center">
                  <a
                     class="o-link-arrow px-1 pt-2"
                     href={viewAllCategories.URL}
                     data-testid="view-all-equipement"
                     {...attributesAnalytics(viewAllCategories.analytics)}
                  >
                     {viewAllCategories.label}
                  </a>
               </div>
            </div>
         </div>
      </div>
   )
}

// Element Equipement Personnalisé
const Equipement = ({ analytics, URL, badge, model, brand, DAS, priceLabel, price, realPrice, financing = '', loan = '', offer, image, index }) => {
   return (
      <li class="col-3">
         <a
            href={URL}
            class="item-recoEquipement"
            data-testid={`reco-equipements${index}`}
            {...attributesAnalytics(analytics)}
         >
            <div class="inner">
               {badge !== '' ? <strong class="tag ob1-tag ob1-tag-primary">{badge}</strong> : ''}

               <h3 class="title js-reco-title">
                  <strong>{brand}</strong> <span>{model}</span>
               </h3>

               <div class="visuel">
                  <img src={image} aria-hidden="true" class="mw-100" loading="lazy" />
               </div>

               <div class="das">
                  {DAS.map((item) => {
                     return (
                        <div>
                           <span>{item.label}&nbsp;:</span> <strong dangerouslySetInnerHTML={{ __html: item.value.replaceAll(' ', '&nbsp;') }}></strong>
                        </div>
                     )
                  })}
               </div>

               <div class="ob1-price">
                  <span class="sr-only">
                     {priceLabel} {price} au lieu de {realPrice}
                  </span>
                  <p aria-hidden="true">
                     <span class="ob1-price-from">{priceLabel}</span>
                     <span class="ob1-price-amount">{price}</span>
                     <span class="ob1-price-without-promo">{realPrice}</span>
                  </p>
               </div>

               {loan !== '' ? (
                  <p class="text-gray3 small text-center p-0" dangerouslySetInnerHTML={{ __html: tagParser(loan) }} />
               ) : (
                  financing !== '' && <span class="ob1-capsule ob1-capsule-context">{financing}</span>
               )}
            </div>
            {offer !== '' ? <div class="offer">{offer}</div> : ''}
         </a>
      </li>
   )
}

// ABTEST 5689 Transparence IA
const TransparenceIA = ({ segRefZ }) => {
   return (
      <Fragment>
         <button
            id="modalButton"
            type="button"
            class="btnIA o-link"
            data-toggle="modal"
            data-target="#exampleModal"
            data-oevent-category="picto_transparence_ia"
            data-oevent-action="en_savoir_plus"
            data-oevent-label="#ouverture_popin"
            data-oevent-other={`{"track_refZ":"acc-digital_${segRefZ}_picto_transparence_ia"}`}
         >
            <span>En savoir plus</span>
            <svg width="14" height="22" viewBox="0 0 14 22" fill="none" xmlns="http://www.w3.org/2000/svg">
               <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M14 6.66966C14 7.77917 13.3334 9.24438 12.4073 10.7151L7.08789 21.4887L2.02016 11.2458C0.9715 9.60222 0.176025 7.91271 0.176025 6.66966C0.176025 3.26845 3.27063 0.51123 7.08803 0.51123C10.9054 0.51123 14 3.26845 14 6.66966ZM7.08755 10.629C9.64384 10.629 11.7161 8.78264 11.7161 6.50505C11.7161 4.22746 9.64384 2.3811 7.08755 2.3811C4.53127 2.3811 2.45898 4.22746 2.45898 6.50505C2.45898 8.78264 4.53127 10.629 7.08755 10.629Z"
                  fill="#555555"
               />
               <path d="M5.3986 4.34424V8.34692H4.45117V4.34424H5.3986Z" fill="#555555" />
               <path
                  d="M6.95049 8.34692H5.93523L7.48219 4.34424H8.70313L10.2479 8.34692H9.23264L8.11017 5.25891H8.07516L6.95049 8.34692ZM6.88704 6.7736H9.28516V7.4342H6.88704V6.7736Z"
                  fill="#555555"
               />
            </svg>
         </button>
         <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
               <div class="modal-content">
                  <div class="modal-header">
                     <button type="button" class="close closeButton croix" data-dismiss="modal" aria-label="Fermer">
                        &times;
                     </button>
                     <button type="button" class="close o-link-arrow back closeButton" data-dismiss="modal">
                        Fermer
                     </button>
                  </div>
                  <div class="modal-body">
                     <h4 id="exampleModalLabel">On vous dit tout sur nos recommandations</h4>
                     <p class="lead font-weight-bold">Comment ça marche ?</p>
                     <p>
                        Prenons un exemple. Vous avez acheté le dernier iPhone dès sa sortie, des AirPods le week-end dernier : on en déduit, à l'aide de notre moteur de
                        recommandations (IA), que vous aimez l'univers Apple et les nouveautés.
                     </p>
                     <p class="lead font-weight-bold">
                        Orange vous propose cette sélection de mobiles, calculée selon vos préférences. Vous en profitez grâce à l'acceptation de nos cookies de personnalisation.
                     </p>
                  </div>
                  <div class="modal-footer d-inline-flex flex-column flex-md-row-reverse justify-content-center">
                     <button class="btn btn-secondary m-0 closeButton" type="button">
                        Fermer
                     </button>
                  </div>
               </div>
            </div>
         </div>
      </Fragment>
   )
}
